export {};

/**
 * Select a category and hide the others
 *
 * @param categoryName of category to show, or 'all' to show everything
 */
window.selectCategory = (categoryName: string) => {
    const categories = document.querySelectorAll("[data-search-category]");

    categories.forEach((category) => {
        if (categoryName === 'all') {
            category.classList.remove('hidden');
            return;
        }

        if (category.getAttribute('data-search-category') === categoryName) {
            category.classList.remove('hidden');
        } else {
            category.classList.add('hidden');
        }
    });
}

// declare global functions
declare global {
    interface Window {
        selectCategory: (categoryName: string) => void,
    }
}